"use strict";
var window = require("global");
var getBrowser = require("./get_adapter_browser");

module.exports = getProperAdapter;

function getProperAdapter() {
	var hasCordova = window.cordova && window.cordova.plugins;
	var hasPhoneRTC = hasCordova && window.cordova.plugins.phonertc;
	var hasiOSRTC = hasCordova && window.cordova.plugins.iosrtc;
	var isMulti = hasPhoneRTC && hasiOSRTC;

	if (isMulti && window.device) {
		var version = window.device.version;
		if (version[0] === "9") return require("./iosrtc");
		else return require("./phonertc");
	}

	if (hasPhoneRTC) return require("./phonertc");
	if (hasiOSRTC) return require("./iosrtc");

	return getBrowser();
}
